export default __webpack_public_path__ + "static/media/prof_roshan.a201936a.jpeg";